import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import RemCalc from '../../utils/rem-calc';

export const ModalBackground = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: -200vw;
  padding: 2rem 0;
  display: flex;
  opacity: 0;
  overflow: auto;
  visibility: hidden;
  z-index: ${themeGet('layers.modal')};
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.5);
  transition:
    opacity 250ms ease-out,
    left 0ms linear 225ms,
    visibility 0ms linear 225ms;

  &.is-active {
    left: 0;
    opacity: 1;
    visibility: visible;
    pointer-events: all;
    transition-delay: 0ms, 0ms, 0ms;
  }
`;

export const ModalContainer = styled.div`
  width: ${RemCalc(700)};
  max-width: 95%;
  margin: auto;
  padding: 5rem 3rem 3rem;
  overflow: hidden;
  z-index: ${themeGet('layers.modal') + 1};
  opacity: 0;
  border-radius: 0.75rem;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.3);
  text-align: center;
  background: ${themeGet('colors.grey-dark')};
  transform: translateY(-2rem);
  transition:
    opacity 200ms ease-out 50ms,
    transform 200ms ease-out 50ms;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    padding: 4.5rem 2rem 2rem;
  }

  @media (max-width: ${themeGet('breakpoints.xs')}) {
    padding: 4rem 1rem 1.5rem;
  }

  &.is-active {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const ModalClose = styled.button`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: transparent;
  border: 0;
  appearance: none;
  cursor: pointer;

  span {
    color: ${themeGet('colors.white')};
    font-size: 1rem;
    font-weight: ${themeGet('fontWeights.medium')};
    position: relative;
  }

  div {
    stroke: ${themeGet('colors.white')};
    stroke-width: 2px;
    border: none;
    width: 1rem;
    height: 1rem;
    float: right;
    margin-left: 0.5rem;
    position: relative;
  }
`;
export const Title = styled.div`
  position: relative;

  h1,
  h2,
  h3 {
    font-size: 3rem;
    font-weight: ${themeGet('fontWeights.bold')};
    margin: 0 auto 1.5rem;
    text-align: center;
    width: 100%;
    color: ${themeGet('colors.white')};
    z-index: 1;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      font-size: 2rem;
    }
  }
`;
export const Description = styled.div`
  position: relative;

  p {
    font-size: 1rem;
    margin: 0 auto 1.5rem;
    text-align: center;
    width: 80%;
    color: ${themeGet('colors.white')};
    z-index: 1;

    @media (max-width: ${themeGet('breakpoints.sm')}) {
      font-size: 0.875rem;
      width: 100%;
    }
  }

  small {
    font-size: 0.8em;
  }
`;

export const WrapperCtas = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  z-index: 1;

  a,
  button {
    margin-left: 1rem;
    margin-right: 1rem;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0);
  width: 100vw;
  height: 102vh;
  top: 0;
  left: 0;
  right: 0;
  margin-top: -2rem;
  visibility: hidden;
  transition:
    visibility 1s,
    background-color 1s linear;
  z-index: 1;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    margin: 0 auto;
    height: 100vh;
  }

  &.hide {
    background-color: rgba(0, 0, 0, 0);
    visibility: hidden;
    transition:
      visibility 0.7s,
      background-color 0.7s linear;
  }
  &.show {
    background-color: rgba(0, 0, 0, 0.5);
    visibility: visible;
    transition:
      visibility 0.7s,
      background-color 0.7s linear;
  }

  &.fixed {
    margin: 0 auto;
    height: 100vh;
  }
`;

export const FlyoutContainer = styled.div`
  width: calc(((100% - 65em) / 2) + 24rem);
  min-width: 24rem;
  padding: 0 5rem;
  height: 102vh;
  background-color: ${themeGet('colors.grey-dark')};
  position: fixed;
  top: 0;
  right: -51vw;
  margin-top: -2rem;
  transition: transform 0.5s cubic-bezier(0, 0.52, 0, 1);
  overflow: auto;
  z-index: 2;
  box-shadow: 0 0 3em rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  @media screen and (max-width: 1200px) {
    width: 75vw;
    right: -80vw;
  }

  @media (max-width: ${themeGet('breakpoints.md')}) {
    margin: 0 auto;
    height: 100vh;
    padding: 0;
    width: 100%;
    padding: 0 3rem;
    right: -105vw;
    align-items: flex-start;
  }

  @media (max-width: ${themeGet('breakpoints.xxs')}) {
    right: -120%;
    padding: 0 2rem;
    min-width: 100%;
  }

  &.hide {
    transform: translate3d(0vw, 0, 0);
    transition: transform 0.5s cubic-bezier(0, 0.52, 0, 1);
  }
  &.show {
    transform: translate3d(-51vw, 0, 0);
    overflow: auto;
    @media screen and (max-width: 1200px) {
      transform: translate3d(-80vw, 0, 0);
    }
    @media screen and (max-width: 768px) {
      transform: translate3d(-105vw, 0, 0);
    }

    @media (max-width: ${themeGet('breakpoints.xxs')}) {
      transform: translate3d(-120%, 0, 0);
    }
  }

  &.fixed {
    margin: 0 auto;
    height: 100vh;
  }
`;

export const FlyoutWrapper = styled.div`
  display: flex;
  width: 100%;
  align-self: flex-start;
  margin-top: 10rem;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    display: table;
    overflow: auto;
    margin: 7rem auto 0;
  }
`;

export const FlyoutContent = styled.div`
  display: table;
  max-width: ${RemCalc(800)};
  width: 100%;
  align-self: center;
  margin: 0 auto;

  a {
    float: left;
    clear: both;
    text-decoration: none;
    font-weight: ${themeGet('fontWeights.semiBold')};
    line-height: 1.8rem;
    color: ${themeGet('colors.white')};
    border-bottom: none;
    transition: all 400ms ease;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      font-size: 0.875rem;
      line-height: 1.5rem;
    }

    &:hover {
      color: ${themeGet('colors.phoenix-red')};
      transition: all 400ms ease;
    }
  }

  hr {
    width: 100%;
    float: left;
    clear: both;
    margin: 1.45rem 0;
  }
`;
export const Legend = styled.div`
  display: table;
  width: 100%;
  margin: 0 auto;

  a {
    font-size: 2rem;
    font-weight: ${themeGet('fontWeights.bold')};
    line-height: 3rem;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      font-size: 1.6rem;
      line-height: 2.5rem;
    }

    @media (max-width: ${themeGet('breakpoints.xxs')}) {
      font-size: 1.4rem;
    }
  }
`;
